// components/DateInput.tsx
import React from "react";
import DatePicker from "react-datepicker";
import { Controller, Control } from "react-hook-form";
import { useRouter } from "src/hooks/useRouter";

interface DateInputProps {
  label: string;
  name: string;
  control: Control<any>;
}

const DateInput: React.FC<DateInputProps> = ({ label, name, control }) => {
  const { lang } = useRouter();
  return (
    <div
      className={`input_date-${name === "startDate" ? "start" : "end"} me-3`}
    >
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <label htmlFor={name}>{label}</label>
            <DatePicker
              id={name}
              selected={field.value ? new Date(field.value) : null}
              onChange={(date: Date | null) => {
                // ISO 문자열로 변환해 저장 (원하는 형식으로 조절 가능)
                field.onChange(date ? date.toISOString().split("T")[0] : null);
              }}
              placeholderText={label}
              dateFormat="yyyy-MM-dd"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              className="date_picker form-control"
              autoComplete="off"
              locale={lang}
            />
          </>
          // <input
          //   id={name}
          //   type="date"
          //   className="form-control"
          //   placeholder={label}
          //   value={field.value || ""}
          //   onChange={field.onChange}
          // />
        )}
      />
    </div>
  );
};

export default DateInput;
